import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item']

  acceptAll() {
    let promises = this.itemControllers.map(itemCtrl => {
      return itemCtrl.accept()
    })

    Promise.all(promises).then(() => {
      this.reloadQueue()
    })
  }

  reloadQueue() {
    let event = new CustomEvent('reload', { bubbles: true })
    this.element.dispatchEvent(event)
  }

  everyItemIsAccepted() {
    return this.itemControllers.every(itemCtrl => {
      return itemCtrl.accepted
    })
  }

  get itemControllers() {
    return this.itemTargets.map(item => {
      return this.application.getControllerForElementAndIdentifier(item, 'ticket-queue-item')
    })
  }
}
